import React from 'react';
import { findParentAndChildLot } from '@iarc-programing/emanufac-utils/functions';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { previousLotReciptDateSafe } from '@/utils/functions';

import MachineTimePairInEquation from './MachineTimePairInEquation';

const MachineCostEquationBox = ({ previousLotList, machine }) => {
  const parentWithChildLots = findParentAndChildLot(previousLotList);

  return (
    <div className="flex gap-2 items-center">
      {_.map(parentWithChildLots, (each, index) => {
        const orderedLot = _.orderBy(
          previousLotReciptDateSafe(
            [each, ...(each?.child_lot || [])],
            'receipt_date',
          ),
        );
        const groupByDatedLots = _.groupBy(orderedLot, 'receipt_date');

        const timeKey = _.keys(groupByDatedLots);
        const pairTimeKey = _.zip(timeKey, timeKey.slice(1));
        const filterPairTime = _.filter(
          pairTimeKey,
          (eachFilterPair) => eachFilterPair?.[1] !== undefined,
        );

        return (
          <div key={index}>
            {_.map(filterPairTime, (eachPair, pairIndex) => (
              <MachineTimePairInEquation
                materialStockLotGroupByDated={groupByDatedLots}
                timePair={eachPair}
                key={pairIndex}
                machine={machine}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default MachineCostEquationBox;

MachineCostEquationBox.propTypes = {
  previousLotList: PropTypes.array,
  machine: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
  }),
};
